import * as React from "react"

import { cn } from "@/lib/utils"

const Textarea = React.forwardRef(({ className, ...props }, ref) => {
  return (
    <textarea
      className={cn(
        // Base styles with 16px font minimum to prevent iOS zoom
        "flex min-h-[80px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm",
        // Placeholder
        "placeholder:text-muted-foreground",
        // Focus states
        "focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring",
        // Disabled
        "disabled:cursor-not-allowed disabled:opacity-50",
        // iOS touch scrolling
        "[-webkit-overflow-scrolling:touch]",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
